import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

import Tooltip from './Tooltip';

const DatesMap = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const _workdays_color = 'var(--main-text-color)';
	const workdays_color = `rgba(${_workdays_color}, 1)`;
	const workdays_color_bg = `rgba(${_workdays_color}, 0.1)`;

	const _weekend_color = 'var(--ep-red-color)';
	const weekend_color = `rgba(${_weekend_color}, 1)`;
	const weekend_color_bg = `rgba(${_weekend_color}, 0.2)`;

	const _past_stage_color = 'var(--ep-midgray-color)';
	const today_color_bg = `rgba(${_weekend_color}, 1)`;
	const closed_stage_bg = `rgba(${_past_stage_color}, 1)`;
	const opened_stage_bg = `rgba(${_weekend_color}, 1)`;
	const pending_stage_bg = `rgba(${_workdays_color}, 1)`;

	const structure_height = 800;	// internal height
	const structure_width = 2000;	// internal width

	const limit_days_to_decide = 100;

	const gotoEdit = (id) => {
		window.location.hash = `/stages/${id}/options`;
	};

	const fakeStartDate = (date) => {
		return `${EPDateFormat(date, 'YYYY-MM-DD')} 00:00:00`;
	};

	const fakeEndDate = (date) => {
		return `${EPDateFormat(date, 'YYYY-MM-DD')} 23:59:59`;
	};

	let promo = props.promo;

	const stages = (props.stages != undefined) ? props.stages : false;
	const out_stages = (props.out_stages != undefined) ? props.out_stages : false;

	const display_stages = (stages !== false) ? true : false;

	let graphic_min_date = '2100-12-31 23:59:59';
	let graphic_max_date = '1970-01-01 00:00:00';

	if(!display_stages || EPDateDiff(fakeEndDate(promo.end_date), fakeStartDate(promo.start_date), 'days') < limit_days_to_decide) {
		graphic_min_date = promo.start_date;
		graphic_max_date = promo.end_date;
	} else {
		stages.map((stage, s) => {
			if(stage.Stage.start_date < graphic_min_date) graphic_min_date = stage.Stage.start_date;
			if(stage.Stage.end_date > graphic_max_date) graphic_max_date = stage.Stage.end_date;
		});
	}

	const num_dates_total = EPDateDiff(fakeEndDate(graphic_max_date), fakeStartDate(graphic_min_date), 'days') + 1;
	const grid_per_day = limit_days_to_decide / num_dates_total;
	const first_day_of_week = EPGetDateDay(fakeStartDate(graphic_min_date));
	const week_displacement = ((8 - first_day_of_week) * grid_per_day) + '%';

	const daynames_styles = {
		fontFamily:"SanFrancisco",
		fontSize:10,
		textLength:grid_per_day + '%',
		textAnchor:'middle',
		y:33,
	};

	const monthnames_styles = {
		fontFamily:"SanFrancisco",
		fontSize:10,
		textAnchor:'left',
		y:13,
	};

	const has_too_many_days = (num_dates_total > limit_days_to_decide) ? true : false;
	const has_many_days = (has_too_many_days || num_dates_total > 40) ? true : false;

	const active_bars = [];
	const hidden_bars = [];

	const today = EPDateFormat(null, 'YYYY-MM-DD 00:00:00');
	const num_dates_from_start = EPDateDiff(today, fakeStartDate(graphic_min_date), 'days');

	if(!display_stages) {
		const num_dates_entry = EPDateDiff(fakeEndDate(promo.end_entry), fakeStartDate(promo.start_entry), 'days') + 1;
		const dates_to_entry = EPDateDiff(fakeEndDate(promo.start_entry), fakeStartDate(graphic_min_date), 'days');
		
		const entry_bar = {
			left:((dates_to_entry * 100) / num_dates_total) + '%',
			width:((num_dates_entry * 100) / num_dates_total) + '%',
		};
		active_bars.push({ class:'entry', color_class:'blueBg', data:entry_bar, label:"Entry dates" });

		const num_dates_voting = EPDateDiff(fakeEndDate(promo.end_voting), fakeStartDate(promo.start_voting), 'days') + 1;
		const dates_to_vote = EPDateDiff(fakeEndDate(promo.start_voting), fakeStartDate(graphic_min_date), 'days');

		const voting_bar = {
			left:`${(dates_to_vote * 100) / num_dates_total}%`,
			width:`${(num_dates_voting * 100) / num_dates_total}%`,
		};

		active_bars.push({
			class:'votes',
			color_class:'greenBg',
			data:voting_bar,
			label:"Voting dates",
		});
	} else {
		stages.map((stage) => {
			const num_dates_stage = EPDateDiff(fakeEndDate(stage.Stage.end_date), fakeStartDate(stage.Stage.start_date), 'days') + 1;
			const dates_to_stage = EPDateDiff(fakeEndDate(stage.Stage.start_date), fakeStartDate(graphic_min_date), 'days');

			const num_dates_from_start_stage = EPDateDiff(today, fakeStartDate(stage.Stage.start_date), 'days');
			const num_dates_from_end_stage = EPDateDiff(today, fakeStartDate(stage.Stage.end_date), 'days');

			const is_opened = (num_dates_from_start_stage > -1) ? true : false;
			const is_closed = (num_dates_from_end_stage > -1) ? true : false;

			var bg_color = pending_stage_bg;
			var tooltip_status = i18n("Coming soon");
			if(is_opened) {
				bg_color = opened_stage_bg;
				tooltip_status = i18n("Open");
			}
			if(is_closed) {
				bg_color = closed_stage_bg;
				tooltip_status = i18n("Closed");
			}

			const stage_bar = {
				backgroundColor:bg_color,
				left:((dates_to_stage * 100) / num_dates_total) + '%',
				width:((num_dates_stage * 100) / num_dates_total) + '%',
			};

			const stage_tooltip = i18n("From") + ": " + EPDateFormat(stage.Stage.start_date, 'llll') + " " + i18n("To: ") + EPDateFormat(stage.Stage.end_date, 'llll') + " " + i18n("Status") + ": " + tooltip_status;

			active_bars.push({
				class:`stage_${stage.Stage.id}`,
				data:stage_bar,
				label:stage.Stage.display_title,
				tooltip:stage_tooltip,
				id:stage.Stage.id,
			});
		});
	}

	if(out_stages !== false && out_stages.length > 0) {
		out_stages.map((stage, s) => {
			const num_dates_stage = EPDateDiff(fakeEndDate(stage.Stage.end_date), fakeStartDate(stage.Stage.start_date), 'days') + 1;
			const dates_to_stage = EPDateDiff(fakeEndDate(stage.Stage.start_date), fakeStartDate(graphic_min_date), 'days');

			const stage_bar = {
				backgroundColor:'rgba(var(--main-bg-color), 1)',
				left:`${(dates_to_stage * 100) / num_dates_total}%`,
				width:`${(num_dates_stage * 100) / num_dates_total}%`,
			};

			const stage_tooltip = `${i18n("From")}: ${EPDateFormat(stage.Stage.start_date, 'llll')} ${i18n("To: ")}${EPDateFormat(stage.Stage.end_date, 'llll')} ${i18n("Status")}: ${i18n("Closed")}`;

			hidden_bars.push({
				class:`is_hidden stage_${stage.Stage.id}`,
				data:stage_bar,
				label:stage.Stage.display_title,
				tooltip:stage_tooltip,
			});
		});
	}

	const months_in_promo = EPDateDiff(fakeEndDate(graphic_max_date), fakeStartDate(graphic_min_date), 'months') + 1;
	const years_in_promo = parseInt(EPDateFormat(fakeEndDate(graphic_max_date), 'Y')) - parseInt(EPDateFormat(fakeEndDate(graphic_min_date), 'Y')) + 1;

	const months = [];
	let first_month = parseInt(EPDateFormat(fakeStartDate(graphic_min_date), 'M'));
	const first_year = parseInt(EPDateFormat(fakeStartDate(graphic_min_date), 'Y'));

	let start_date_left_acc = 0;
	for(let j = first_year; j < first_year + years_in_promo; j++) {
		for(let i = first_month; i < Math.max(12, first_month + months_in_promo) + 1; i++) {
			const num_dates_in_month = EPGetDaysInMonth(`${j}-${((i < 10) ? `0${i}` : i)}`);
			const is_last_month = (i == first_month + months_in_promo) ? true : false;

			const days_from_month_start = Math.max(0, EPDateDiff(fakeEndDate(graphic_min_date), `${j}-${(i < 10) ? `0${i}` : i}-01`, 'days'));
			const days_from_month_end = Math.max(0, EPDateDiff(`${j}-${(i < 10) ? `0${i}` : i}-${num_dates_in_month}`, fakeEndDate(graphic_max_date), 'days'));

			let num_days_in_month_active = num_dates_in_month - days_from_month_start - days_from_month_end;
			if(is_last_month) num_days_in_month_active -= 1;

			const _w = (num_days_in_month_active * 100) / num_dates_total;
			if(_w > 0) {
				months.push({
					left:start_date_left_acc + '%',
					width:`${_w}%`,
					label:EPDateFormat(`${j}-${(i < 10) ? `0${i}` : i}`, 'MMM-Y'),
				});
				start_date_left_acc += _w;
			}

			if(i == 12) first_month = 1;
		}
	}

	const daynames_arr = (window.is_spanish) ? ['L', 'M', 'X', 'J', 'V', 'S', 'D'] : ['M', 'T', 'W', 'T', 'F', 'S', 'S'];

	return (
		<div class="gui_dates_path">
			<div class="svg_grid is_fullscreen relative_to_container">
				<svg class="default_svg" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
					<defs>
						<pattern
							id="daynames"
							width={`${grid_per_day * 14}%`}
							height="100%"
							patternUnits="userSpaceOnUse"
							x={week_displacement}
						>
							<text
								x={`${0 * grid_per_day + grid_per_day / 2}%`}
								fill={workdays_color}
								{...daynames_styles}
							>{daynames_arr[0]}</text>

							{(!has_many_days) && (
								<text
									x={`${1 * grid_per_day + grid_per_day / 2}%`}
									fill={workdays_color}
									{...daynames_styles}
								>{daynames_arr[1]}</text>
							)}

							{(!has_too_many_days) && (
								<text
									x={`${2 * grid_per_day + grid_per_day / 2}%`}
									fill={workdays_color}
									{...daynames_styles}
								>{daynames_arr[2]}</text>
							)}

							{(!has_many_days) && (
								<text
									x={`${3 * grid_per_day + grid_per_day / 2}%`}
									fill={workdays_color}
									{...daynames_styles}
								>{daynames_arr[3]}</text>
							)}

							{(!has_too_many_days) && (
								<text
									x={`${4 * grid_per_day + grid_per_day / 2}%`}
									fill={workdays_color}
									{...daynames_styles}
								>{daynames_arr[4]}</text>
							)}

							{(!has_many_days) && (
								<text
									x={`${5 * grid_per_day + grid_per_day / 2}%`}
									fill={weekend_color}
									{...daynames_styles}
								>{daynames_arr[5]}</text>
							)}

							{(!has_too_many_days) && (
								<text
									x={`${6 * grid_per_day + grid_per_day / 2}%`}
									fill={weekend_color}
									{...daynames_styles}
								>{daynames_arr[6]}</text>
							)}

							{(!has_many_days || has_too_many_days) && (
								<text
									x={`${7 * grid_per_day + grid_per_day / 2}%`}
									fill={workdays_color}
									{...daynames_styles}
								>{daynames_arr[0]}</text>
							)}

							{(!has_too_many_days) && (
								<text
									x={`${8 * grid_per_day + grid_per_day / 2}%`}
									fill={workdays_color}
									{...daynames_styles}
								>{daynames_arr[1]}</text>
							)}

							{(!has_many_days) && (
								<text
									x={`${9 * grid_per_day + grid_per_day / 2}%`}
									fill={workdays_color}
									{...daynames_styles}
								>{daynames_arr[2]}</text>
							)}

							{(!has_too_many_days) && (
								<text
									x={`${10 * grid_per_day + grid_per_day / 2}%`}
									fill={workdays_color}
									{...daynames_styles}
								>{daynames_arr[3]}</text>
							)}

							{(!has_many_days) && (
								<text
									x={`${11 * grid_per_day + grid_per_day / 2}%`}
									fill={workdays_color}
									{...daynames_styles}
								>{daynames_arr[4]}</text>
							)}

							{(!has_too_many_days) && (
								<text
									x={`${12 * grid_per_day + grid_per_day / 2}%`}
									fill={weekend_color}
									{...daynames_styles}
								>{daynames_arr[5]}</text>
							)}

							{(!has_many_days) && (
								<text
									x={`${13 * grid_per_day + grid_per_day / 2}%`}
									fill={weekend_color}
									{...daynames_styles}
								>{daynames_arr[6]}</text>
							)}
						</pattern>

						<pattern
							id="day_grid"
							width={`${grid_per_day}%`}
							height="100%"
							patternUnits="userSpaceOnUse"
						>
							<path
								d={`M 0 0 L 0 0 0 ${structure_height}`}
								fill="none"
								stroke={workdays_color}
								strokeWidth="0.2"
							/>
						</pattern>

						<pattern
							id="weekend_grid"
							width={`${grid_per_day * 7}%`}
							height="100%"
							patternUnits="userSpaceOnUse"
							patternTransform="scale(-1 1)"
						>
							<rect
								width={`${grid_per_day * 2}%`}
								x={0}
								height={structure_height}
								fill={weekend_color_bg}
							/>
						</pattern>

						<pattern
							id="week_grid"
							width={`${grid_per_day * 7}%`}
							height="100%"
							patternUnits="userSpaceOnUse"
							x={week_displacement}
						>
							<rect
								width={`${grid_per_day * 7}%`}
								x={0}
								height={structure_height}
								fill="url(#weekend_grid)"
							/>

							<rect
								width={`${grid_per_day * 7}%`}
								height={structure_height}
								fill="url(#day_grid)"
							/>
						</pattern>

						<pattern
							id="month_box_first"
							width="100%"
							height="100%"
							patternUnits="objectBoundingBox"
						>
							<rect
								width="100%"
								height={40}
								x={0}
								y={0}
								fill={workdays_color_bg}
							/>
						</pattern>

						<pattern
							id="month_box_other"
							width="100%"
							height="100%"
							patternUnits="objectBoundingBox"
						>
							<rect
								width="100%"
								height={40}
								x={0}
								y={0}
								fill={workdays_color_bg}
							/>

							<rect
								width="200%"
								height={40}
								x={0}
								y={-10}
								fill="none"
								stroke={workdays_color}
								strokeWidth={3}
							/>
						</pattern>

						<pattern
							id="month_grid_first"
							width="100%"
							height={structure_height}
							patternUnits="objectBoundingBox"
						/>

						<pattern
							id="month_grid_other"
							width="100%"
							height="100%"
							patternUnits="objectBoundingBox"
						>
							<rect
								width="200%"
								height={structure_height}
								x={0}
								y={-10}
								fill="none"
								stroke={workdays_color}
								strokeWidth={3}
							/>
						</pattern>
					</defs>

					<g id="today">
						<rect
							width={(grid_per_day / 2) + '%'}
							y={40}
							x={(grid_per_day * num_dates_from_start + grid_per_day / 4) + '%'}
							height={structure_height - 40}
							fill={today_color_bg}
						/>
					</g>

					{months.map((month, m) => {
						const pattern = (m == 0) ? 'month_box_first' : 'month_box_other';
						const pattern_grid = (m == 0) ? 'month_grid_first' : 'month_grid_other';

						return (
							<g key={`m_${m}`}>
								<rect
									width={month.width}
									height={20}
									x={month.left}
									y={0}
									fill={`url(#${pattern})`}
								/>

								<text
									dx={8}
									x={month.left}
									fill={workdays_color}
									{...monthnames_styles}
								> {month.label}</text>

								<rect
									width={month.width}
									height="100%"
									x={month.left}
									y={20}
									fill={`url(#${pattern_grid})`} 
								/>
							</g>
						)
					})}

					<g>
						<rect
							width="100%"
							height={20}
							y={20}
							fill="url(#daynames)"
						/>

						<path
							d={`M 0 0 L 0 0 ${structure_width} 0`}
							fill="none"
							stroke={workdays_color}
							strokeWidth={2}
						/>

						<path
							d={`M 0 20 L 0 20 ${structure_width} 20`}
							fill="none"
							stroke={workdays_color}
							strokeWidth={1}
						/>

						<path
							d={`M 0 40 L 0 40 ${structure_width} 40`}
							fill="none"
							stroke={workdays_color}
							strokeWidth={2}
						/>
					</g>

					<rect
						width="100%"
						height="100%"
						y={20}
						fill="url(#week_grid)"
					/>
				</svg>
			</div>

			<div class="bars_list">
				{hidden_bars.length > 0 && hidden_bars.map((bar, b) => {
					const classes = ['bar'];
					if(bar.color_class != undefined) classes.push(bar.color_class);

					return (
						<div key={`hidden_bar_${b}`} class={bar.class}>
							<div class={classes.join(" ")} style={bar.data}>
								<span class="blackColor gui_cutTextOnOverflow">{bar.label}</span>

								{(bar.tooltip != undefined) && (
									<Tooltip
										autotranslate={false}
										position="top"
										with_icon={false}
									>{bar.tooltip}</Tooltip>
								)}
							</div>
						</div>
					)
				})}

				{active_bars.map((bar, b) => {
					const classes = ['bar'];
					if(bar.color_class != undefined) classes.push(bar.color_class);

					return (
						<div key={`bar_${b}`} class={bar.class}>
							<div class={classes.join(" ")} style={bar.data} onClick={() => gotoEdit(bar.id)}>
								<span class="whiteColor gui_cutTextOnOverflow">{bar.label}</span>

								{(bar.tooltip != undefined) && (
									<Tooltip
										autotranslate={false}
										position="top"
										with_icon={false}
									>{bar.tooltip}</Tooltip>
								)}
							</div>
						</div>
					)
				})}
			</div>
		</div>
	);
};

export default injectIntl(DatesMap);